{
  "title": "Activity Log",
  "subtitle": "Every company's user logins and actions, in one place — visible only to the platform SuperAdmin.",
  "columns": {
    "date": "Date & Time",
    "company": "Company",
    "platform": "Platform",
    "user": "User",
    "module": "Module",
    "action": "Action",
    "details": "Details",
    "severity": "Severity"
  }
}
